import { render, staticRenderFns } from "./RemoteConfigurationUploadFormTemplate.vue?vue&type=template&id=fa94ce4e&scoped=true&"
import script from "./RemoteConfigurationUploadFormTemplate.vue?vue&type=script&lang=ts&"
export * from "./RemoteConfigurationUploadFormTemplate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa94ce4e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VFileInput,VForm})
